import PlatzhalterIcon from '../assets/Platzhalter.svg';
import UnreadDocuments from '../assets/Ungelesene_Dokumente.svg';
import Hausverwaltung from '../assets/Ansprechpersonen/Hausverwaltung.svg';
import GrossinstandTech from '../assets/Ansprechpersonen/Großinstandhaltungstechniker.svg';
import Bautechniker from '../assets/Ansprechpersonen/Bautechniker.svg';
import InstandTech from '../assets/Ansprechpersonen/Instandhaltungstechniker.svg';
import Wohnungsvermarktung from '../assets/Ansprechpersonen/Wohnungsvermarktung.svg';
import Eigentuemerwechsel from '../assets/Ansprechpersonen/Eigentümerwechsel.svg';
import Mieterwechsel from '../assets/Ansprechpersonen/Mieterwechsel.svg';
import Jahresabrechnung from '../assets/Ansprechpersonen/Jahresabrechnung.svg';
import GrossinstandBuchhaltung from '../assets/Ansprechpersonen/Großinst_Buchhaltung.svg';
import Dokumente from '../assets/Kontoauszug/Dokumente.svg';
import Buchungen from '../assets/Kontoauszug/Buchungen.svg';
import Mail from '../assets/MeineDaten/Mail.svg';
import MeineUploads from '../assets/MeineDaten/MeineUploads.svg';
import OnlineZustellung from '../assets/MeineDaten/OnlineZustellung.svg';
import PersonenbezDaten from '../assets/MeineDaten/PersonenbezDaten.svg';
import Phone from '../assets/MeineDaten/Phone.svg';
import Zahlungsdaten from '../assets/MeineDaten/Zahlungsdaten.svg';
import Signature from '../assets/MeineDaten/Signature.svg';
import Stocks from '../assets/icons/Stocks.svg';

let currentIcon: string;

function useIcon(iconTitle?: string) {
  if (iconTitle === 'Ungelesene Dokumente') {
    currentIcon = UnreadDocuments;
  } else if (iconTitle === 'Hausverwalter/In') {
    currentIcon = Hausverwaltung;
  } else if (iconTitle === 'Großinstandsetzungstechniker') {
    currentIcon = GrossinstandTech;
  } else if (iconTitle === 'Bautechniker/In') {
    currentIcon = Bautechniker;
  } else if (iconTitle === 'Instandhaltungstechniker/In') {
    currentIcon = InstandTech;
  } else if (iconTitle === 'Wohnungsvermarktung') {
    currentIcon = Wohnungsvermarktung;
  } else if (iconTitle === 'Eigentümerwechsel') {
    currentIcon = Eigentuemerwechsel;
  } else if (iconTitle === 'Mieterwechsel') {
    currentIcon = Mieterwechsel;
  } else if (iconTitle === 'Jahresabrechnung') {
    currentIcon = Jahresabrechnung;
  } else if (iconTitle === 'Großinstandsetzungsbuchhaltung') {
    currentIcon = GrossinstandBuchhaltung;
  } else if (iconTitle === 'Dokumente') {
    currentIcon = Dokumente;
  } else if (iconTitle === 'Buchungen') {
    currentIcon = Buchungen;
  } else if (iconTitle === 'Email') {
    currentIcon = Mail;
  } else if (iconTitle === 'Meine Uploads') {
    currentIcon = MeineUploads;
  } else if (iconTitle === 'Online-Zustellung') {
    currentIcon = OnlineZustellung;
  } else if (iconTitle === 'Personenbezogene Daten') {
    currentIcon = PersonenbezDaten;
  } else if (iconTitle === 'Kontaktdaten') {
    currentIcon = Phone;
  } else if (iconTitle === 'Zahlungsdaten') {
    currentIcon = Zahlungsdaten;
  } else if (iconTitle === 'Digitale Unterschrift') {
    currentIcon = Signature;
  } else if (iconTitle === 'Ölpreise') {
    currentIcon = Stocks;
  } else if (iconTitle === 'Haushaltsversicherung') {
    currentIcon = Hausverwaltung;
  } else {
    currentIcon = PlatzhalterIcon;
  }
  return currentIcon;
}

export default useIcon;
